import axios from "axios";
import { hostname } from "src/HostName";
import { decryptData } from "./decryptcookie";
import Cookies from "universal-cookie";


let logoutTimer; 
const axiosInstance = axios.create({
  baseURL : hostname,
    headers: {
      'key' :'1f67cc92078c59d28345211501c21b3e98b23de4aabe94ccfe872fc6d8a7d5253530e7',
    }
});

const axiosPrivate = axios.create({
  baseURL: hostname,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json",
  },
});

axiosPrivate.interceptors.request.use(
  (config) => {
    const user = decryptData("_b60-g6fr_plus");
    const token = user?.token
     
    if (token) {
      config.headers["x-access-token"] = `${token}`; 
    }
    return config;
  },
  (error) => {
    console.log("error",error)
    return Promise.reject(error);
  }
);
axiosPrivate.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const cookies = new Cookies();

    if (error.response && error.response.status === 401) {
      // console.log("error",error);
      function logout() {
          // alert("Session expired. Please log in again.");
          cookies.remove("_s_t2_ai_token", { path: "/" });
          cookies.remove("_b60-g6fr_plus", { path: "/" });
          localStorage.removeItem("otpVerified");
          localStorage.setItem("LoginState", false); // Clear session-related data
          window.location.href = "/"; // Redirect to login
      }
      
      if (logoutTimer) {
        clearTimeout(logoutTimer);
      }
      
      // Debounce the logout to prevent multiple calls
      logoutTimer = setTimeout(() => {
        logout();
      }, 1000); // Small delay to catch multiple 401s
    
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

const request = async ({ method = 'get', url, data = null, params = null, headers = {} }) => {
  try {
    const config = {
      method,
      url,
      data,
      params,
      headers: {
        ...axiosPrivate.defaults.headers.common,
        ...headers,
      },
    };

    const response = await axiosPrivate(config);
    return response.data;
  } catch (error) {
    console.error(`API request failed for ${url}:`, error);
    throw error;
  }
};

// Convenience methods for common HTTP verbs
const apiClient = {
  get: (url, params, headers) => request({ method: 'get', url, params, headers }),
  post: (url, data, headers) => request({ method: 'post', url, data, headers }),
  put: (url, data, headers) => request({ method: 'put', url, data, headers }),
  patch: (url, data, headers) => request({ method: 'patch', url, data, headers }),
  delete: (url, data, headers) => request({ method: 'delete', url, data, headers }),
};


export {axiosPrivate ,apiClient}
export default axiosInstance;
